import { render, staticRenderFns } from "./UserAllowRegistrationToggle.vue?vue&type=template&id=47e8f142&"
import script from "./UserAllowRegistrationToggle.vue?vue&type=script&lang=js&"
export * from "./UserAllowRegistrationToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports